import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileAttention.tsx
const IconFileAttention = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 48 48",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M34.5 39.625v-2.25h3v2.25z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#fc6060",
			fillRule: "evenodd",
			d: "M36 46c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10m-1.5-6.375v3h3v-3zm3-2.25v-8h-3v8z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#f5b5b5",
			fillRule: "evenodd",
			d: "M6 16 18.006 4h21.99C41.103 4 42 4.91 42 5.984v17.363A13.95 13.95 0 0 0 36 22c-7.732 0-14 6.268-14 14 0 2.974.928 5.732 2.51 8H7.986C6.89 44 6 43.1 6 41.986zm3 2L20 7v11z",
			clipRule: "evenodd"
		})
	]
});
var IconFileAttention_default = forwardRef(IconFileAttention);
//#endregion
export { IconFileAttention_default as default };
